.popup {
    composes: fontST16 from "../../styles/typography.module.scss";
    display: flex;
    flex-direction: column;
    align-items: start;
    background: var(--white);
    padding: var(--spacer-16);
    gap: var(--spacer-12);
    border-radius: var(--border-radius-sm);
    box-shadow: var(--box-shadow-3);

    svg {
        height: 100%;
        margin-left: 0;
        margin-right: var(--spacer-8);
    }
}

.arrow {
    polygon {
        fill: var(--white);
    }

    width: 16px;
    height: 12px;
}

.shareItem {
    composes: base from "../Clickables/index.module.scss";
    padding-inline: var(--spacer-4);

    &:hover,
    &[data-hovered] {
        color: var(--red);
    }
}

// RAC should really have something less weird than this available...
[data-testid="underlay"] {
    background: var(--transparent-40);
}

.root {
    display: flex;
    align-items: center;

    > * {
        align-items: baseline;

        &[data-hovered] svg {
            transform: unset;
        }
    }
}
